import React, { useContext, useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom'
import { AddDeleteUpadate, fetchPostData } from '@/Components/hooks/Api';
import DataTable from 'react-data-table-component';
import { toastifyError, toastifySuccess } from '@/Components/Common/AlertMsg';
import { AgencyContext } from 'Context/Agency';
import { RequiredFieldIncident } from '@/Components/Pages/Utility/Personnel/Validation';
import { Decrypt_Id_Name, isLockOrRestrictModule, tableCustomStyles } from '@/Components/Common/Utility';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { get_LocalStoreData } from '@/redux/actions/Agency';
import { get_ScreenPermissions_Data } from '@/redux/actions/IncidentAction';
import { check_OffenceCode_NoneUnknown } from '@/Components/Pages/Property/PropertyNibrsError';
import VehicleListing from '@/Components/Pages/ShowAllList/VehicleListing';

const Offense = (props) => {

  const { ListData, DecVehId, DecMVehId, IncID, isLocked, setIsLocked } = props

  const dispatch = useDispatch();
  const localStoreData = useSelector((state) => state.Agency.localStoreData);
  const effectiveScreenPermission = useSelector((state) => state.Incident.effectiveScreenPermission);
  const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
  const useQuery = () => {
    const params = new URLSearchParams(useLocation().search);
    return {
      get: (param) => params.get(param)
    };
  };

  const query = useQuery();
  let MstPage = query?.get('page');
  const { get_vehicle_Count, setChangesStatus } = useContext(AgencyContext);
  const SelectedValue = useRef();

  const [ownerData, setOwnerData] = useState();
  const [loginPinID, setLoginPinID,] = useState('');
  const [ownerIdDrp, setOwnerIdDrp] = useState([]);
  const [nibrsCodeArr, setNibrsCodeArr] = useState([]);
  const [propLossCode, setPropLossCode] = useState('');
  const [selectedOffenses, setSelectedOffenses] = useState([]);

  const [value, setValue] = useState({
    'MasterPropertyID': '', 'PropertyID': '', 'labal': '', 'IncidentID': '', 'OffenseID': null,
    'CreatedByUserFK': '', 'IsMaster': MstPage === "MST-Property-Dash" ? true : false,
  })

  const [errors, setErrors] = useState({
    'OwnerIDError': '',
  });

  useEffect(() => {
    if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
      if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
    }
  }, []);

  useEffect(() => {
    if (localStoreData) {
      setLoginPinID(localStoreData?.PINID);
      // old code - P063  
      dispatch(get_ScreenPermissions_Data("V137", localStoreData?.AgencyID, localStoreData?.PINID));
    }
  }, [localStoreData]);

  useEffect(() => {
    if (DecVehId || DecMVehId) {
      get_Data_Owner(DecVehId, DecMVehId, IncID);
      setValue({
        ...value,
        'IncidentID': IncID, 'PropertyID': DecVehId, 'CreatedByUserFK': loginPinID, 'MasterPropertyID': DecMVehId, 'labal': '', 'OffenseID': null,
      })
    }
  }, [DecVehId, DecMVehId]);

  useEffect(() => {
    if (IncID) { get_OwnerID_Drp(IncID); }
  }, [IncID])

  const check_Validation_Error = (e) => {
    if (RequiredFieldIncident(value.OffenseID)) {
      setErrors(prevValues => { return { ...prevValues, ['OwnerIDError']: RequiredFieldIncident(value.OffenseID) } })
    }
  }

  const { OwnerIDError } = errors

  useEffect(() => {
    if (OwnerIDError === 'true') {
      Add_Owner()
    }
  }, [OwnerIDError])

  const get_Data_Owner = (propertyID, DecMVehId, mainIncidentID) => {
    const val = { 'PropertyID': propertyID, 'MasterPropertyID': DecMVehId ? DecMVehId : 0, 'IncidentID': mainIncidentID, 'OffenseID': 0, 'IsMaster': MstPage === "MST-Property-Dash" ? true : false, }
    fetchPostData('PropertyOffense/GetData_PropertyOffense', val).then((res) => {
      if (res) {
        setOwnerData(res);
        const nibrsCodeArr = res?.filter((item) => {
          if (item?.NIBRSCode != '23A' && item?.NIBRSCode != '23B' && item?.NIBRSCode != '23C' && item?.NIBRSCode != '23D' && item?.NIBRSCode != '23E' && item?.NIBRSCode != '23F' && item?.NIBRSCode != '23G' && item?.NIBRSCode != '23H') { return item }
        });
        setNibrsCodeArr(nibrsCodeArr);
        setPropLossCode(res[0]?.PropertyReasonsCode);
        // Update selectedOffenses with current selected offense IDs
        const selectedIds = res.map(item => item.OffenseID);
        setSelectedOffenses(selectedIds);
      } else {
        setOwnerData([]);
        setNibrsCodeArr([]);
        setPropLossCode('');
        setSelectedOffenses([]);
      }
      get_OwnerID_Drp(mainIncidentID, res);
    });
  }

  const get_OwnerID_Drp = (mainIncidentID, ownerData) => {
    const val = { 'IncidentID': mainIncidentID, 'OffenseID': 0, }
    fetchPostData('PropertyOffense/GetDataDropDown_PropertyOffense', val).then((data) => {
      if (data) {
        setOwnerIdDrp(shortArr(ownerData, data));
      } else {
        setOwnerIdDrp([]);
      }
    })
  }

  const shortArr = (ownerData, data) => {
    const ids = []
    ownerData?.forEach(({ OffenseID }) => ids.push(OffenseID))
    const shortArr = data?.filter(obj1 => !ownerData?.some(obj2 => obj1.CrimeID === obj2.OffenseID));
    return shortArr
  }

  // Handle checkbox change for DataTable
  const handleCheckboxChange = (offenseId, isChecked) => {
    if (isChecked) {
      // Add to selected offenses
      setSelectedOffenses(prev => {
        if (prev.includes(offenseId)) return prev;
        return [...prev, offenseId];
      });
      // Call insert API
      const offenseItem = ownerIdDrp?.find(item => item.CrimeID === offenseId);
      if (offenseItem) {
        const val = {
          'IncidentID': IncID,
          'PropertyID': DecVehId,
          'CreatedByUserFK': loginPinID,
          'IsMaster': MstPage === "MST-Property-Dash" ? true : false,
          'MasterPropertyID': DecMVehId,
          'labal': offenseItem.Offense_Description,
          'OffenseID': offenseId,
        };
        AddDeleteUpadate('PropertyOffense/Insert_PropertyOffense', val).then((res) => {
          const parsedData = JSON.parse(res.data);
          const message = parsedData.Table[0].Message;
          toastifySuccess(message);
          get_vehicle_Count(DecVehId, DecMVehId, MstPage === "MST-Property-Dash" ? true : false);
          get_Data_Owner(DecVehId, DecMVehId, IncID);
          get_OwnerID_Drp(IncID);
        }).catch((err) => {
          console.error("🚀 ~ Insert PropertyOffense ~ err:", err);
          // Remove from selected if insert fails
          setSelectedOffenses(prev => prev.filter(id => id !== offenseId));
        });
      }
    } else {
      // Remove from selected offenses
      setSelectedOffenses(prev => prev.filter(id => id !== offenseId));
      // Find the PropertyOffenseID from ownerData
      const offenseToDelete = ownerData?.find(item => item.OffenseID === offenseId);
      if (offenseToDelete) {
        const val = {
          'propertyOffenseID': offenseToDelete.PropertyOffenseID,
          'DeletedByUserFK': loginPinID,
        };
        AddDeleteUpadate('PropertyOffense/Delete_PropertyOffense', val).then((res) => {
          const parsedData = JSON.parse(res.data);
          const message = parsedData.Table[0].Message;
          toastifySuccess(message);
          get_vehicle_Count(DecVehId, DecMVehId, MstPage === "MST-Property-Dash" ? true : false);
          get_Data_Owner(DecVehId, DecMVehId, IncID);
          get_OwnerID_Drp(IncID);
        }).catch((err) => {
          console.error("🚀 ~ Delete PropertyOffense ~ err:", err);
          // Add back to selected if delete fails
          setSelectedOffenses(prev => [...prev, offenseId]);
        });
      }
    }
  };

  const Add_Owner = () => {
    const result = ownerData?.find(item => {
      if (item.OffenseID === value.OffenseID) {
        return item.OffenseID === value.OffenseID
      } else return item.OffenseID === value.OffenseID
    });
    if (result) {
      toastifyError('Offence Already Exists');
      setErrors({
        ...errors,
        ['OwnerIDError']: '',
      })
    } else if (value.OffenseID !== '') {
      const { IncidentID, PropertyID, CreatedByUserFK, MasterPropertyID, labal, OffenseID, IsMaster } = value
      const val = {
        'IncidentID': IncID, 'PropertyID': DecVehId, 'CreatedByUserFK': loginPinID, 'IsMaster': IsMaster,
        'MasterPropertyID': DecMVehId, 'labal': labal, 'OffenseID': OffenseID,
      }
      AddDeleteUpadate('PropertyOffense/Insert_PropertyOffense', val).then((res) => {

        setChangesStatus(false);
        const parsedData = JSON.parse(res.data);
        const message = parsedData.Table[0].Message;
        toastifySuccess(message);
        get_vehicle_Count(DecVehId, DecMVehId, MstPage === "MST-Property-Dash" ? true : false);
        get_Data_Owner(DecVehId, DecMVehId, IncID);
        get_OwnerID_Drp(IncID);
        onClear();
        setErrors({ ...errors, ['OwnerIDError']: '', })
      })
    }
  }

  const onClear = () => {
    SelectedValue?.current?.clearValue();
    setValue(pre => { return { ...pre, ['OffenseID']: '', ['propertyOffenseID']: '', ['labal']: '' } });
    setErrors({});

  };

  // Combine ownerIdDrp with ownerData to show all offenses
  const allOffenses = [...(ownerIdDrp || [])];
  (ownerData || []).forEach(selectedOffense => {
    // Check if offense already exists in ownerIdDrp
    const existingIndex = allOffenses.findIndex(off => off.CrimeID === selectedOffense.OffenseID);
    if (existingIndex !== -1) {
      // Update existing item to include selected offense data
      allOffenses[existingIndex] = {
        ...allOffenses[existingIndex],
        ...selectedOffense,
        isFromSelected: true
      };
    } else {
      // Add new item from selected offenses
      allOffenses.push({
        ...selectedOffense,
        CrimeID: selectedOffense.OffenseID,
        isFromSelected: true
      });
    }
  });

  // Sort: items with isFromSelected=true at top, then alphabetically by label
  const sortedAllOffenses = allOffenses.sort((a, b) => {
    // First, prioritize items from selected (isFromSelected: true)
    if (a.isFromSelected && !b.isFromSelected) return -1;
    if (!a.isFromSelected && b.isFromSelected) return 1;

    // If both have same isFromSelected status, sort alphabetically by label
    const labelA = a.Offense_Description?.toLowerCase() || '';
    const labelB = b.Offense_Description?.toLowerCase() || '';
    return labelA.localeCompare(labelB);
  });

  const columns = [
    {
      name: '',
      width: '60px',
      cell: (row) => (
        <input
          type="checkbox"
          checked={selectedOffenses.includes(row.CrimeID || row.OffenseID)}
          onChange={(e) => handleCheckboxChange(row.CrimeID || row.OffenseID, e.target.checked)}
          disabled={isLockOrRestrictModule("Lock", ownerData, isLocked, true)}
          style={{ cursor: isLockOrRestrictModule("Lock", ownerData, isLocked, true) ? 'not-allowed' : 'pointer' }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Offense Code/Name',
      selector: (row) => row.Offense_Description,
      sortable: true
    },
    {
      name: 'Attempted/Completed',
      selector: (row) => row.AttemptComplete || '',
      sortable: true,
      width: "140px",
    },
    {
      name: 'TIBRS Code',
      selector: (row) => row.NIBRSCode ? row.NIBRSCode : '',
      sortable: true,
      cell: (row) => {
        const isChecked = selectedOffenses.includes(row.CrimeID || row.OffenseID);
        const errorStr = check_OffenceCode_NoneUnknown(row.NIBRSCode, row?.PropertyReasonsCode || propLossCode, row.AttemptComplete, row?.PropDescCode, nibrsCodeArr);
        const tibrsCode = row.NIBRSCode || '';

        // Always show TIBRS Code, but only show error tooltip icon when checked and there's an error
        if (isChecked && errorStr) {
          return (
            <span>
              {tibrsCode}
              {' '}
              <span className='hovertext' data-hover={errorStr}>
                <i className='fa fa-exclamation-circle'></i>
              </span>
            </span>
          );
        } else {
          return <span>{tibrsCode || row?.FBICode}</span>;
        }
      },
    },
  ]

  const conditionalRowStyles = [
    {
      when: (row) => {
        const isChecked = selectedOffenses.includes(row.CrimeID || row.OffenseID);
        const errorStr = check_OffenceCode_NoneUnknown(row.NIBRSCode, row?.PropertyReasonsCode || propLossCode, row.AttemptComplete, row?.PropDescCode, nibrsCodeArr);
        // Only highlight if checked and has error
        return isChecked && errorStr;
      },
      style: { backgroundColor: "rgb(255 202 194)" },
    },
  ];
  return (
    <>
      <VehicleListing {...{ ListData }} />
      <div className="col-12">
        <div className='row'>
          <label htmlFor="" className='label-name ' style={{ fontSize: "15px" }}>Please Select the Offense Associate with this Vehicle</label>
        </div>
        <div className="col-12 mt-2 mb-3">
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <DataTable
              columns={columns}
              data={effectiveScreenPermission ? effectiveScreenPermission[0]?.DisplayOK ? sortedAllOffenses : [] : sortedAllOffenses}
              noDataComponent={effectiveScreenPermission ? effectiveScreenPermission[0]?.DisplayOK ? "No offenses available" : "You don't have permission to view data" : 'No offenses available'}
              dense
              highlightOnHover
              fixedHeader
              persistTableHead={true}
              customStyles={{
                ...tableCustomStyles,
                tableWrapper: {
                  style: {
                    maxHeight: '300px',
                  },
                },
              }}
              conditionalRowStyles={conditionalRowStyles}
              fixedHeaderScrollHeight='300px'
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default Offense